
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-document-utilisateur',
    templateUrl: './document-utilisateur.component.html',
    styleUrls: ['./document-utilisateur.component.scss'],
    imports: [
    MatIcon,
    TranslateModule,
    RouterOutlet
]
})
export class DocumentUtilisateurComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
